export default (Alpine) => {

	Alpine.store('twirePageText', {

		pages: {

			single: {},
			multi: {},
			rich: {}

		},
		initFromDOM(jsonString) {

			try {

				const data = JSON.parse(jsonString);

				this.pages = { ...this.pages, ...data };

			} catch (e) {

				console.error('TWire: Failed to parse page text JSON', e);
		
			}

		},
		get val() {

			return (type, path) => {

				if (!this.pages[type]) {

					return '';

				}

				return path.split('.').reduce((obj, key) => {

					return obj && obj[key] !== undefined ? obj[key] : undefined;

				}, this.pages[type]);

			};

		}

	});

};